import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const ADMIN_COOKIE_NAME = 'admin_access';
const ADMIN_COOKIE_VALUE = 'milekeeper_admin_2024'; // You should change this to a secure value

export default function CodesAdmin() {
  const [hasAccess, setHasAccess] = useState(false);
  const [cookieInput, setCookieInput] = useState('');

  useEffect(() => {
    const adminCookie = Cookies.get(ADMIN_COOKIE_NAME);
    if (adminCookie === ADMIN_COOKIE_VALUE) {
      setHasAccess(true);
    }
  }, []);

  const handleCookieSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (cookieInput === ADMIN_COOKIE_VALUE) {
      Cookies.set(ADMIN_COOKIE_NAME, cookieInput, { expires: 365 }); // Cookie expires in 1 year
      setHasAccess(true);
    } else {
      alert('Invalid access code');
    }
  };

  if (hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold mb-4">Admin Access</h1>
          <p className="text-gray-600">You have access. Coming soon...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-4">Admin Access</h1>
        <form onSubmit={handleCookieSubmit} className="space-y-4">
          <div>
            <label htmlFor="cookie" className="block text-sm font-medium text-gray-700">
              Enter Access Code
            </label>
            <input
              type="password"
              id="cookie"
              value={cookieInput}
              onChange={(e) => setCookieInput(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Enter access code"
            />
          </div>
          <button
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
} 